import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { HardwareSpielwieseComponent } from './hardware/hardware.component';

// IOs

const routes: Routes = [
	{
		path: 'hardwarespielwiese',
		component: HardwareSpielwieseComponent,
		data: { title: 'Hardwarespielwiese' }
	}
];

@NgModule({
	imports: [LayoutsModule, RouterModule.forChild(routes)],
	providers: [],
	exports: [RouterModule]
})
export class IORouterModule {}
